const { sendUtagEvent } = IB.utag_events

// Events after submit form request

export function errorFormResponsEvent(form, formName) {
  const purposeValue = formName === 'personal information' ? 'loyalty' : 'information'
  const eventAct = `error form-${formName}`
  sendUtagEvent({
    data: {
      event_name: 'error_form',
      event_cat: 'form',
      event_act: eventAct,
      event_lbl: '',
      event_purpose: purposeValue,
      event_structure: 'body',
    },
  })
}

export function successFormResponsEvent(form, formName) {
  const purposeValue = formName === 'personal information' ? 'loyalty' : 'information'
  const eventAct = `success form-${formName}`
  sendUtagEvent({
    data: {
      event_name: 'success_form',
      event_cat: 'form',
      event_act: eventAct,
      event_lbl: '',
      event_purpose: purposeValue,
      event_structure: 'body',
    },
  })
}
